import React from 'react';
import './App.css';
import Header from './container/Header';
import MainContainer from'./container/MainContainer'
import {useState } from 'react'
import Login from './container/Login';
import  { provider , auth } from './firebase'
function App() {
  const [user,setUser] = useState();
  const signin = ()=>{
    auth.signInWithPopup(provider).then(result => {setUser(result.user)}).catch( err => alert(err));
} 
const Guest = () =>{
     setUser({"displayName" : "Guest" , "photoURL" : 'https://res.cloudinary.com/dcpks831z/image/upload/v1597084254/sample.jpg' , "email" : 'guest@gmail.com'});
}
  return (
    <div className="App">
      {user ?
          <>
              <Header user={user} />
              <MainContainer user={user} />
          </>
            :

          <>
            <Login Signin={signin} Guest={Guest} />
          </>
      }
    </div>
  );
}

export default App;
